import { render, staticRenderFns } from "./commissionList.vue?vue&type=template&id=2027a80b&scoped=true"
import script from "./commissionList.vue?vue&type=script&lang=js"
export * from "./commissionList.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/order/dialog-bonus.scss?vue&type=style&index=0&lang=scss&external"
import style1 from "./commissionList.vue?vue&type=style&index=1&id=2027a80b&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2027a80b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2027a80b')) {
      api.createRecord('2027a80b', component.options)
    } else {
      api.reload('2027a80b', component.options)
    }
    module.hot.accept("./commissionList.vue?vue&type=template&id=2027a80b&scoped=true", function () {
      api.rerender('2027a80b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/examination/commissionList.vue"
export default component.exports